import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { MetacomState } from "@core/models/metacom.interface";
import { StoreDetailsState } from "@core/models/store.interface";

import { Store } from "@ngrx/store";
import { selectMetacomDetails } from "@shared/store/metacom/selectors";
import { selectStoreDetails } from "@shared/store/store-details/selectors";
import {
  hasNestedEmptyValues,
  isEmptyObject,
} from "@shared/utils/objects.util";
import { combineLatest, map, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class StartupGuard {
  constructor(
    private store: Store<{
      storeDetails: StoreDetailsState;
      metacom: MetacomState;
    }>,
    private router: Router
  ) {}
  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    return this.canActivate(route, state);
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return combineLatest([
      this.store.select(selectStoreDetails),
      this.store.select(selectMetacomDetails),
    ]).pipe(
      map(([storeDetails, metacomDetails]) => {
        if (
          !isEmptyObject(storeDetails) &&
          !isEmptyObject(metacomDetails) &&
          !hasNestedEmptyValues(storeDetails) &&
          !hasNestedEmptyValues(metacomDetails)
        ) {
          return true;
        } else {
          this.router.navigate(["/404"]);
          return false;
        }
      })
    );
  }
}
